import { Chip, Typography } from "@mui/material";
import { isNil } from "lodash";

interface Props {
  shipmentStatus: ShipmentStatusValue | null;
  size: "small" | "medium";
}

const getChipProps = (
  status: ShipmentStatusValue | null,
): { color: "error" | "success"; label: string } | null => {
  switch (status) {
    case "BOOKING_CANCELLED":
      return {
        color: "error",
        label: "CANCELLED",
      };
    case "DELIVERED":
      return {
        color: "success",
        label: "DELIVERED",
      };
    case "PICKED_UP":
      return {
        color: "success",
        label: "PICKED UP",
      };
    default:
      return null;
  }
};

export function OptionalShipmentStatusBadge(props: Props) {
  const { shipmentStatus, size } = props;

  const chipProps = getChipProps(shipmentStatus);

  if (isNil(chipProps)) {
    return null;
  }

  return (
    <Chip
      label={<Typography variant="subtitle2">{chipProps.label}</Typography>}
      color={chipProps.color}
      size={size}
      variant="outlined"
    />
  );
}
